<template>
<section>

	<div class="flex-row">
		<div>User:</div>
		<div class="ml-05 mb-05">
			<b>
				<div>{{ modalMessageAction.userFirstName }} {{ modalMessageAction.userLastName }}</div>
				<div>{{ modalMessageAction.userEmail }}</div>
			</b>
		</div>
	</div>

	<div>Action: <b>{{ modalMessageAction.action }}</b></div>
	<div class="mb-05">ResponseID: <b>{{ modalMessageAction.responseID || 'none' }}</b></div>

	<div>Location: <b>{{ modalMessageAction.displayLocation }}</b></div>
	<div>License Key: <b>{{ modalMessageAction.licenseKey }}</b></div>
	<div>Time: <b>{{ modalMessageAction.time.toLocaleString() }}</b></div>

	<table class="table mt-1">
		<tr>
			<td class="table-data label">Time in Program:</td>
			<td class="table-data value">{{ modalMessageAction.hoursInProgramString || '--' }}</td>
		</tr>
		<tr>
			<td class="table-data label"># Logins:</td>
			<td class="table-data value">{{ modalMessageAction.numLogins || '--' }}</td>
		</tr>
		<tr>
			<td class="table-data label">License Age:</td>
			<td class="table-data value">{{ modalMessageAction.hoursPurchaseString || '--' }}</td>
		</tr>
		<tr>
			<td class="table-data label">Account Age:</td>
			<td class="table-data value">{{ modalMessageAction.hoursAccountString || '--' }}</td>
		</tr>
	</table>

</section>
</template>


<script>
export default {
	name: 'ModalMessageActionDetails',

	props: {
		modalMessageAction: Object,
	},
}
</script>


<style scoped>
.label {
	text-align: right;
}
.value {
	text-align: left;
	font-weight: bold;
}
</style>